import * as Yup from 'yup';

const mediaRewardsSchema = Yup.object().shape({
  MediaRewardsTimeCount: Yup.number().required('زمان دیدن ویدیو الزامی است'),
  MeidaRewardsValue: Yup.number().required('مقدار پاداش الزامی است'),
  MediaRewardsScore: Yup.number().required('امتیاز پاداش الزامی است'),
  MediaRewardsClubPoint: Yup.number().required('امتیاز باشگاه الزامی است'),
  MediaRewardsUserLevel: Yup.number().required('سطح کاربر الزامی است'),
});

export { mediaRewardsSchema };
